import { axios } from '../../services/ServiceUtils';
import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { countrySelectorClicked, signInButtonClicked } from './unifiedMastheadEvents';
import { useLanguageContext } from '../../contexts/LanguageContext';

function getTrustedScriptSrc(src) {
  if (!src) return null;
  try {
    const url = new URL(src, 'https://invalid.local');
    if (url.protocol !== 'https:') return null;
    const hostname = url.hostname.toLowerCase();
    const legacyMastheadPattern = /^www\.dell\.com$/;
    const v2MastheadPattern = /^unified-masthead-md-.*\.pnp.*\.pcf\.dell\.com$/;
    return legacyMastheadPattern.test(hostname) || v2MastheadPattern.test(hostname) ? url.href : null;
  } catch {
    return null;
  }
}


const Header = ({ language }) => {
  const [header, setHeader] = useState("");
  const { setLanguage } = useLanguageContext();

  useEffect(() =>  {
    // We need to improve useLanguageContext, rendering to many times
    countrySelectorClicked((e) => setLanguage instanceof Function && setLanguage({ locale: e.detail.lc }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    disposeScriptTags('um-dfspublic-header-script');
    const locale = language.locale.toLowerCase();
    const sessionStorageKey = `header-html-${locale}`;
    const headerHtml = sessionStorage.getItem(sessionStorageKey);
    setHeader("");
    if (headerHtml) {
      setTimeout(() => setHeader( headerHtml), 0);
    }
    else {
      axios
        .get(`api/masthead/header/${locale}`)
        .then((result) => {
          sessionStorage.setItem(sessionStorageKey, result.data);
          setHeader(result.data);
        })
        .catch(e => {
          console.error('request error', e);
        });
    }

  }, [language]);

  return (
    <>
      {parse(header, { replace: renderCountrySelectorScript })}
    </>
  );

};

export default Header;


function renderCountrySelectorScript(domNode) {
  if (domNode.type === 'script' 
    && domNode?.attribs?.id !== ""
    && document.head.querySelectorAll(`#${domNode?.attribs?.id}`)?.length === 0) {
    const trustedScriptSrc = getTrustedScriptSrc(domNode?.attribs?.src);
    if (!trustedScriptSrc) return <></>;
    instantiateScriptTags(trustedScriptSrc, domNode?.attribs?.id);
    return <></>;
  }
};

function instantiateScriptTags(src, id) {
  const scriptElem = document.createElement('script');
  if(src?.length > 0) scriptElem.src = src;
  if(id?.length > 0) scriptElem.id = id;
  scriptElem.defer = true;
  document.head.appendChild(scriptElem);
}

function disposeScriptTags(id) {
  if(!id) return;
  const existingScripts = document.head.querySelectorAll(`#${id}`);
  existingScripts.forEach(scriptElem => scriptElem?.remove());
}

function onSignIn () {
  try {
    console.log('called onSignIn')
    const elem = document.getElementById("bannerSignIn");
    if (!elem) return;

    var style = elem.style;
    if (style.display === "block") style.display = "none";
    else style.display = "block";
  } catch (e) {
    console.error('bannerSignIn:', e);
  }
}

signInButtonClicked(onSignIn);
